var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTermsAndConditions)?_c('form-section',{attrs:{"no-validity":""}},[_c('lg-terms-and-conditions')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }